import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ViewStakingPlan({ show, onHide, viewData, cryptocurrencies }) {
    const { t } = useTranslation();

    const getCoinName = (id) => {
        const crypto = cryptocurrencies.find(c => c.id === id);
        return crypto ? `${crypto.coin_symbol} (${crypto.symbol})` : id;
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{t('view_staking_plan')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <td>{t('cryptocurrency')}</td>
                            <td>{getCoinName(viewData.cryptocurrency_id)}</td>
                        </tr>
                        <tr>
                            <td>{t('daily_reward_percent')}</td>
                            <td>{viewData.daily_reward_percent}</td>
                        </tr>
                        <tr>
                            <td>{t('staking_type')}</td>
                            <td>{viewData.staking_type}</td>
                        </tr>
                        <tr>
                            <td>{t('locking_days')}</td>
                            <td>{viewData.locking_days}</td>
                        </tr>
                        <tr>
                            <td>{t('daily_reward_cryptocurrency')}</td>
                            <td>{getCoinName(viewData.daily_reward_cryptocurrency_id)}</td>
                        </tr>
                        <tr>
                            <td>{t('min_daily_reward_withdraw_limit')}</td>
                            <td>{viewData.minimum_daily_reward_withdraw_limit}</td>
                        </tr>
                        <tr>
                            <td>{t('referral_purchase_bonus_percent')}</td>
                            <td>{viewData.referral_purchase_bonus_percent}</td>
                        </tr>
                        <tr>
                            <td>{t('referral_matching_bonus_percent')}</td>
                            <td>{viewData.referral_matching_bonus_percent}</td>
                        </tr>
                        <tr>
                            <td>{t('stake_fee_status')}</td>
                            <td>{viewData.stake_fee_status}</td>
                        </tr>
                        {viewData.stake_fee_status === "ON" && (
                            <>
                                <tr>
                                    <td>{t('stake_fee_cryptocurrency')}</td>
                                    <td>{getCoinName(viewData.stake_fee_cryptocurrency_id)}</td>
                                </tr>
                                <tr>
                                    <td>{t('stake_fee_type')}</td>
                                    <td>{viewData.stake_fee_type}</td>
                                </tr>
                                <tr>
                                    <td>{t('stake_fee_amount')}</td>
                                    <td>{viewData.stake_fee_amount}</td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td>{t('status')}</td>
                            <td>{viewData.status}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>{t('close')}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewStakingPlan;
